import { GridBox } from "../../DetailedPlayer";
import { Row } from "../components/Row";
import { PlayStyle } from "./Shared";
import { playStyleIds } from "./Shared";

export const DetailedPlayStylesSection = ({
  playStylesPlus,
  playStyles,
  isGk,
}: {
  playStylesPlus: number[];
  playStyles: number[];
  isGk: boolean;
}) => {
  return (
    <GridBox
      title="PlayStyles"
      className="col-span-4 touch-device:col-span-2 min-h-[394px] hidden mobile:block"
    >
      <div className="flex flex-col">
        <Row
          title="Scoring"
          height="h-14"
          stretch
          value={
            <div className="flex flex-row gap-x-2">
              {playStyleIds["scoring"]?.map((id: number) => {
                const hasPlus = playStylesPlus?.includes(id);
                const hasNormal = playStyles?.includes(id);
                return (
                  <PlayStyle
                    hasPlus={hasPlus}
                    hasNormal={hasNormal}
                    id={id}
                    key={id}
                  />
                );
              })}
            </div>
          }
        />
        <Row
          title="Passing"
          height="h-14"
          stretch
          value={
            <div className="flex flex-row gap-x-2">
              {playStyleIds["passing"]?.map((id: number) => {
                const hasPlus = playStylesPlus?.includes(id);
                const hasNormal = playStyles?.includes(id);
                return (
                  <PlayStyle
                    hasPlus={hasPlus}
                    hasNormal={hasNormal}
                    id={id}
                    key={id}
                  />
                );
              })}
              <div className="w-12" />
            </div>
          }
        />
        <Row
          title="Defending"
          height="h-14"
          stretch
          value={
            <div className="flex flex-row gap-x-2">
              {playStyleIds["defending"]?.map((id: number) => {
                const hasPlus = playStylesPlus?.includes(id);
                const hasNormal = playStyles?.includes(id);
                return (
                  <PlayStyle
                    hasPlus={hasPlus}
                    hasNormal={hasNormal}
                    id={id}
                    key={id}
                  />
                );
              })}
            </div>
          }
        />
        <Row
          title="Ball Control"
          height="h-14"
          stretch
          value={
            <div className="flex flex-row gap-x-2">
              {playStyleIds["ball-control"]?.map((id: number) => {
                const hasPlus = playStylesPlus?.includes(id);
                const hasNormal = playStyles?.includes(id);
                return (
                  <PlayStyle
                    hasPlus={hasPlus}
                    hasNormal={hasNormal}
                    id={id}
                    key={id}
                  />
                );
              })}
            </div>
          }
        />
        <Row
          title="Physical"
          height="h-14"
          stretch
          value={
            <div className="flex flex-row gap-x-2">
              {playStyleIds["physical"]?.map((id: number) => {
                const hasPlus = playStylesPlus?.includes(id);
                const hasNormal = playStyles?.includes(id);
                return (
                  <PlayStyle
                    hasPlus={hasPlus}
                    hasNormal={hasNormal}
                    id={id}
                    key={id}
                  />
                );
              })}
            </div>
          }
        />
        <Row
          title="Goalkeeping"
          height="h-14"
          stretch
          hiddenBorder
          value={
            <div className="flex flex-row gap-x-2">
              {playStyleIds["goalkeeping"]?.map((id: number) => {
                const hasPlus = playStylesPlus?.includes(id);
                const hasNormal = playStyles?.includes(id);
                return (
                  <PlayStyle
                    hasPlus={hasPlus}
                    hasNormal={hasNormal}
                    id={id}
                    key={id}
                  />
                );
              })}
            </div>
          }
        />
      </div>
    </GridBox>
  );
};
